import { assert, log } from '../app/logger.js';
import { AutocompleteControl } from '../controls/autocomplete_control.js';
import { locationTaxonomy } from '../data/location_taxonomy.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { window } from '../window.js';

/**
 * Location type autocomplete control.
 */
class LocTypeControl extends AutocompleteControl {
  constructor() {
    super();

    this.noAutoSelectOnUpdate = true;
    this.placeholder = 'Location type';

    listenToEvent(this, 'itemselect', ev => this.#handleOnSelect(ev.detail));
  }

  initialize() {
    super.initialize();

    this.classList.add('loctype-autocomplete');
    this.leftButtonsElement.innerHTML = `
      <div class='editable-control-list-item' hidden></div>
    `;
  }

  get category() {
    return this.#category;
  }
  get type() {
    return this.value;
  }

  set(category, type) {
    log(
      `[control:loctype] schedule set to category: '${category}', type: '${type}'`
    );
    this.value = type || '';
    return this.scheduleItemsUpdate().then(hash => {
      if (hash != this.scheduleItemsUpdateHash) {
        log(
          `[control:loctype] cancel set to category: '${category}', type: '${type}'`
        );
        return;
      }
      log(`[control:loctype] set to category: '${category}', type: '${type}'`);
      let index = this.itemsData.findIndex(
        i => i.category == category && i.name == type
      );
      if (index == -1) {
        index = this.itemsData.findIndex(
          i => i.class == 'loc-category' && i.category == category
        );
      }

      let data = this.itemsData[index];
      this.#category = (data && data.category) || '';
      this.categoryElement.textContent = (data && data.categoryName) || '';
      this.categoryElement.hidden = !data;
      this.selectedIndex = index;
      if (data && data.class == 'loc-category') {
        this.value = '';
      }
    });
  }

  requestItems(term) {
    let items = [];
    for (let {
      category,
      categoryName,
      subtypes,
    } of locationTaxonomy.hierarchy) {
      let categoryMatched = categoryName
        .toLowerCase()
        .includes(term.toLowerCase());

      subtypes = subtypes.filter(
        t => !term || t.toLowerCase().includes(term.toLowerCase())
      );

      if (!term || categoryMatched || subtypes.length > 0) {
        items.push({
          category,
          categoryName,
          name: categoryName,
          class: 'loc-category',
          matched: categoryMatched,
        });
        for (let subtype of subtypes) {
          items.push({
            category,
            categoryName,
            name: subtype,
            class: 'loc-type',
            matched: true,
          });
        }
      }
    }
    return items;
  }

  setItemsNSelect(items) {
    this.setItems(items);
    this.selectedIndex = items.findIndex(i => i.matched);
  }

  #handleOnSelect(item) {
    assert(item, `[control:loctype] no item`);
    this.#category = item.category;
    this.categoryElement.textContent = item.categoryName;
    this.categoryElement.hidden = false;
    if (item.class == 'loc-category') {
      this.value = '';
    }

    this.setItems(this.requestItems(''));

    let selectedIndex =
      (item && this.itemsData.findIndex(i => item.name == i.name)) || -1;
    this.selectedIndex = selectedIndex;
    if (selectedIndex != -1) {
      this.scrollSelectedIntoView();
    }

    this.focus();
  }

  #category;

  static get selectors() {
    const baseSelectors = super.selectors;
    return Object.assign({}, baseSelectors, {
      Category: `${baseSelectors.LeftButtons} > .editable-control-list-item`,
    });
  }

  static get elements() {
    return {
      categoryElement: this.selectors.Category,
    };
  }
}

window.customElements.define('loctype-control', LocTypeControl);

export { LocTypeControl };
